import React from 'react';
import Widget from '../Widget/Widget.js'
import './TwitterWidget.css'
import { Timeline } from 'react-twitter-widgets'

class TwitterWidget extends React.Component {

  getTheme() {
    if(this.props.useDarkTheme) {
      return "dark"
    } else {
      return "light"
    }
  }

  render() {

    var dataSource = {};

    if(this.props.twitterWidgetId) {
      dataSource = {
        widgetId: this.props.twitterWidgetId
      }
    } else if(this.props.twitterScreenName) {
      dataSource = {
        sourceType: 'profile',
        screenName: this.props.twitterScreenName
      }
    }
    return (
      <Widget {...this.props}>
        <div className="row widget-fullheight-row">
          <div className="col align-self-center twitter-widget-col">
            <Timeline
               dataSource={dataSource}
               options={{
                 username: '3EN_ltd',
                 chrome: "noheader,nofooter",
                 theme: this.getTheme(),
                 height:"100%",
                 width:"100%"
               }}
            />
          </div>
        </div>
      </Widget>
    )
  }
}

export default TwitterWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/TwitterWidget/TwitterWidget.js